export default __webpack_public_path__ + "static/media/03.d18374b0.png";